import { Model, attr } from 'redux-orm';

import ActionTypes from '../constants/ActionTypes';

export default class extends Model {
  static modelName = 'Dashboard';

  static fields = {
    component: attr(),
    isFetching: attr({
      getDefault: () => null,
    }),
  };

  static reducer({ type, payload }, Dashboard) {
    switch (type) {
      case ActionTypes.DASHBOARD_FETCH_SUCCEEDED:
        payload.dashboard.forEach((component) => {
          Dashboard.upsert(component);
        });

        break;
      case ActionTypes.COMPONENT_CREATE_SUCCESSDED:
      case ActionTypes.COMPONENT_CREATE_RECEIVED:
        Dashboard.upsert(payload.data);

        break;
      case ActionTypes.COMPONENT_UPDATE_SUCCESSDED:
      case ActionTypes.COMPONENT_UPDATE_RECEIVED:
        if (Dashboard.withId(payload.id)) {
          Dashboard.withId(payload.id).update(payload.data);
        } else {
          Dashboard.upsert(payload.data);
        }

        break;
      case ActionTypes.COMPONENT_DELETE_SUCCESSDED:
      case ActionTypes.COMPONENT_DELETE_RECEIVED: {
        const dashboard = Dashboard.withId(payload.id);
        if (dashboard) {
          dashboard.delete();
        }

        break;
      }
      case ActionTypes.DEVICE_ITEMS_UPDATE_RECEIVED: {
        const allComponents = Dashboard.all().toRefArray();
        const cpType6 = allComponents.find(
          (cp) => cp.component === 'type6' && payload.items.deviceId === cp.deviceId,
        );
        if (cpType6?.items?.[0]) {
          const cpType6Value = cpType6?.items?.[0]?.valueAndTime;
          cpType6Value.shift();
          cpType6Value.push({
            value: payload.items?.values?.[cpType6.itemName],
            loggedAt: payload.items?.loggedAt,
          });
          cpType6.items[0].valueAndTime = cpType6Value;
          const dashboard = Dashboard.withId(cpType6.id);
          if (dashboard) {
            dashboard.update({
              ...cpType6,
            });
          }
        }

        break;
      }
      default:
    }
  }

  static getOrderedQuerySet() {
    return this.orderBy('position');
  }
}
